import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { checkAndRefreshToken } from 'utils/authUtils';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';


export const shopsApi = createApi({
  reducerPath: 'shops',


  baseQuery: createBaseQueryWithReauth('/shops'),
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: false,
  keepUnusedDataFor: 1,

  endpoints: builder => ({
    fetchShops: builder.query({
      query: () => '',
      providesTags: ['Shops'],
    }),
    createShop: builder.mutation({
      query: (data) => ({
        url: '/create',
        method: 'POST',
        body: data,
      
        params: {
          name: data.name,        // Передача name через параметри запиту (query params)
          address: data.address,  // Передача address через параметри запиту (query params)
        },
      }),
      invalidatesTags: ['Shops'],
    }),
    deleteShop: builder.mutation({
      query: id => ({
        url: `/delete?id=${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Shops'],
    }),
     toggleShopWorking: builder.mutation({
      query: ({ id, status }) => ({
        url: '/toggle-working',
        method: 'POST',
        params: {
          id,
          status, // 1 або 0
        },
      }),
      invalidatesTags: ['Shops'],
    }),

    // ======================
    // POST /shops/working-hours?id=
    // ======================
    updateShopWorkingHours: builder.mutation({
      query: ({ id, works_from, works_to }) => ({
        url: '/working-hours',
        method: 'POST',
        params: { id },
        body: {
          works_from,
          works_to,
        },
      }),
      invalidatesTags: ['Shops'],
    }),
  }),
});
export const {
  useFetchShopsQuery,
  useCreateShopMutation,
  useDeleteShopMutation,
   useToggleShopWorkingMutation,
  useUpdateShopWorkingHoursMutation,

} = shopsApi;
